/** How long a window is, and the accent each officer type's windows are drawn in (see components/DurationPill). */

/** The accent of each officer type's windows: SOS pink, OT amber, Main blue. */
export const WINDOW_COLORS = { SOS: '#e879a0', OT: '#f59e0b', MAIN: '#1e40af' } as const;

/** "12h", "2h 30m", "45m"; '' for no time at all. */
export function formatWindowMinutes(mins: number): string {
  if (mins <= 0) return '';
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return h > 0 ? `${h}h${m > 0 ? ` ${m}m` : ''}` : `${m}m`;
}
